module.exports = __webpack_public_path__ + "static/media/1015473.9c198715.png";